var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-main",
    { staticClass: "Edit-main" },
    [
      _c(
        "el-row",
        { staticClass: "row-gap" },
        [
          _c("el-col", { staticClass: "label-col", attrs: { span: 3 } }, [
            _vm._v("创意名称：")
          ]),
          _vm._v(" "),
          _c("el-col", { staticClass: "value-col", attrs: { span: 21 } }, [
            _vm._v(_vm._s(_vm.entity.ideaName))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "row-gap" },
        [
          _c("el-col", { staticClass: "label-col", attrs: { span: 3 } }, [
            _vm._v("投放单元：")
          ]),
          _vm._v(" "),
          _c("el-col", { staticClass: "value-col", attrs: { span: 21 } }, [
            _vm._v(_vm._s(_vm.entity.putUnitInfo.putUnitName))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "row-gap" },
        [
          _c("el-col", { staticClass: "label-col", attrs: { span: 3 } }, [
            _vm._v("创意类型：")
          ]),
          _vm._v(" "),
          _c("el-col", { staticClass: "value-col", attrs: { span: 21 } }, [
            _vm._v(_vm._s(_vm.entity.ideaTypeInfo.ideaTypeName))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "row-gap" },
        [
          _c("el-col", { staticClass: "label-col", attrs: { span: 3 } }, [
            _vm._v("出价类型：")
          ]),
          _vm._v(" "),
          _c("el-col", { staticClass: "value-col", attrs: { span: 21 } }, [
            _vm._v(_vm._s(_vm.entity.bidTypeText))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "row-gap" },
        [
          _c("el-col", { staticClass: "label-col", attrs: { span: 3 } }, [
            _vm._v("目标出价：")
          ]),
          _vm._v(" "),
          _c("el-col", { staticClass: "value-col", attrs: { span: 21 } }, [
            _vm._v(_vm._s(_vm.entity.simulateBidText))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.entity.assetsList, function(item, index) {
        return [
          item.assetsId === 1
            ? _c(
                "el-row",
                { key: index, staticClass: "row-gap" },
                [
                  _c(
                    "el-col",
                    { staticClass: "label-col", attrs: { span: 3 } },
                    [_vm._v("Icon：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "value-col", attrs: { span: 21 } },
                    [
                      item.value.url
                        ? _c("el-image", {
                            staticStyle: { width: "64px", height: "64px" },
                            attrs: {
                              src: item.value.url,
                              "preview-src-list": [item.value.url],
                              fit: "contain"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          item.assetsId === 2
            ? _c(
                "el-row",
                { key: index, staticClass: "row-gap" },
                [
                  _c(
                    "el-col",
                    { staticClass: "label-col", attrs: { span: 3 } },
                    [_vm._v("Logo：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "value-col", attrs: { span: 21 } },
                    [
                      item.value.url
                        ? _c("el-image", {
                            staticStyle: { width: "64px", height: "64px" },
                            attrs: {
                              src: item.value.url,
                              "preview-src-list": [item.value.url],
                              fit: "contain"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          item.assetsId === 3
            ? _c(
                "el-row",
                { key: index, staticClass: "row-gap" },
                [
                  _c(
                    "el-col",
                    { staticClass: "label-col", attrs: { span: 3 } },
                    [_vm._v("主图片：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "value-col", attrs: { span: 21 } },
                    [
                      item.value.url
                        ? _c("el-image", {
                            staticStyle: {
                              border: "1px solid #ccc",
                              width: "300px",
                              height: "200px"
                            },
                            attrs: {
                              src: item.value.url,
                              "preview-src-list": [item.value.url],
                              fit: "contain"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          item.assetsId === 4
            ? _c(
                "el-row",
                { key: index, staticClass: "row-gap" },
                [
                  _c(
                    "el-col",
                    { staticClass: "label-col", attrs: { span: 3 } },
                    [_vm._v("图片二：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "value-col", attrs: { span: 21 } },
                    [
                      item.value.url
                        ? _c("el-image", {
                            staticStyle: {
                              border: "1px solid #ccc",
                              width: "300px",
                              height: "200px"
                            },
                            attrs: {
                              src: item.value.url,
                              "preview-src-list": [item.value.url],
                              fit: "contain"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          item.assetsId === 5
            ? _c(
                "el-row",
                { key: index, staticClass: "row-gap" },
                [
                  _c(
                    "el-col",
                    { staticClass: "label-col", attrs: { span: 3 } },
                    [_vm._v("图片三：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "value-col", attrs: { span: 21 } },
                    [
                      item.value.url
                        ? _c("el-image", {
                            staticStyle: {
                              border: "1px solid #ccc",
                              width: "300px",
                              height: "200px"
                            },
                            attrs: {
                              src: item.value.url,
                              "preview-src-list": [item.value.url],
                              fit: "contain"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          item.assetsId === 6
            ? _c(
                "el-row",
                { key: index, staticClass: "row-gap" },
                [
                  _c(
                    "el-col",
                    { staticClass: "label-col", attrs: { span: 3 } },
                    [_vm._v("标题：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "value-col", attrs: { span: 21 } },
                    [_vm._v(_vm._s(item.value))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          item.assetsId === 7
            ? _c(
                "el-row",
                { key: index, staticClass: "row-gap" },
                [
                  _c(
                    "el-col",
                    { staticClass: "label-col", attrs: { span: 3 } },
                    [_vm._v("描述：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "value-col", attrs: { span: 21 } },
                    [_vm._v(_vm._s(item.value))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          item.assetsId === 8
            ? _c(
                "el-row",
                { key: index, staticClass: "row-gap" },
                [
                  _c(
                    "el-col",
                    { staticClass: "label-col", attrs: { span: 3 } },
                    [_vm._v("评分：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "value-col", attrs: { span: 21 } },
                    [_vm._v(_vm._s(item.value))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          item.assetsId === 9
            ? _c(
                "el-row",
                { key: index, staticClass: "row-gap" },
                [
                  _c(
                    "el-col",
                    { staticClass: "label-col", attrs: { span: 3 } },
                    [_vm._v("好评数：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "value-col", attrs: { span: 21 } },
                    [_vm._v(_vm._s(item.value))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          item.assetsId === 10
            ? _c(
                "el-row",
                { key: index, staticClass: "row-gap" },
                [
                  _c(
                    "el-col",
                    { staticClass: "label-col", attrs: { span: 3 } },
                    [_vm._v("落地页链接：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "value-col", attrs: { span: 21 } },
                    [_vm._v(_vm._s(item.value))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          item.assetsId === 11
            ? _c(
                "el-row",
                { key: index, staticClass: "row-gap" },
                [
                  _c(
                    "el-col",
                    { staticClass: "label-col", attrs: { span: 3 } },
                    [_vm._v("APP名称：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "value-col", attrs: { span: 21 } },
                    [_vm._v(_vm._s(item.value))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          item.assetsId === 12
            ? _c(
                "el-row",
                { key: index, staticClass: "row-gap" },
                [
                  _c(
                    "el-col",
                    { staticClass: "label-col", attrs: { span: 3 } },
                    [_vm._v("APP下载链接：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "value-col", attrs: { span: 21 } },
                    [_vm._v(_vm._s(item.value))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          item.assetsId === 13
            ? _c(
                "el-row",
                { key: index, staticClass: "row-gap" },
                [
                  _c(
                    "el-col",
                    { staticClass: "label-col", attrs: { span: 3 } },
                    [_vm._v("打开应用URL：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "value-col", attrs: { span: 21 } },
                    [_vm._v(_vm._s(item.value))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          item.assetsId === 14
            ? _c(
                "el-row",
                { key: index, staticClass: "row-gap" },
                [
                  _c(
                    "el-col",
                    { staticClass: "label-col", attrs: { span: 3 } },
                    [_vm._v("APP包名：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "value-col", attrs: { span: 21 } },
                    [_vm._v(_vm._s(item.value))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          item.assetsId === 15
            ? _c(
                "el-row",
                { key: index, staticClass: "row-gap" },
                [
                  _c(
                    "el-col",
                    { staticClass: "label-col", attrs: { span: 3 } },
                    [_vm._v("展示监控：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "value-col", attrs: { span: 21 } },
                    [
                      _c(
                        "ul",
                        _vm._l(item.value.split(","), function(link, index) {
                          return _c(
                            "li",
                            { key: index, staticClass: "track-link" },
                            [_vm._v(_vm._s(link))]
                          )
                        }),
                        0
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          item.assetsId === 16
            ? _c(
                "el-row",
                { key: index, staticClass: "row-gap" },
                [
                  _c(
                    "el-col",
                    { staticClass: "label-col", attrs: { span: 3 } },
                    [_vm._v("点击监控：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "value-col", attrs: { span: 21 } },
                    [
                      _c(
                        "ul",
                        _vm._l(item.value.split(","), function(link, index) {
                          return _c(
                            "li",
                            { key: index, staticClass: "track-link" },
                            [_vm._v(_vm._s(link))]
                          )
                        }),
                        0
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          item.assetsId === 17
            ? _c(
                "el-row",
                { key: index, staticClass: "row-gap" },
                [
                  _c(
                    "el-col",
                    { staticClass: "label-col", attrs: { span: 3 } },
                    [_vm._v("视频：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "value-col", attrs: { span: 21 } },
                    [
                      item.value.video_url
                        ? _c(
                            "video",
                            {
                              staticStyle: {
                                border: "1px solid #ccc",
                                width: "300px",
                                height: "200px"
                              },
                              attrs: {
                                src: item.value.video_url,
                                muted: "",
                                autoplay: "",
                                loop: ""
                              },
                              domProps: { muted: true }
                            },
                            [_vm._v("您的浏览器不支持 video 标签")]
                          )
                        : _vm._e()
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          item.assetsId === 18
            ? _c(
                "el-row",
                { key: index, staticClass: "row-gap" },
                [
                  _c(
                    "el-col",
                    { staticClass: "label-col", attrs: { span: 3 } },
                    [_vm._v("APP版本：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "value-col", attrs: { span: 21 } },
                    [_vm._v(_vm._s(item.value))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          item.assetsId === 19
            ? _c(
                "el-row",
                { key: index, staticClass: "row-gap" },
                [
                  _c(
                    "el-col",
                    { staticClass: "label-col", attrs: { span: 3 } },
                    [_vm._v("APP开发者：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "value-col", attrs: { span: 21 } },
                    [_vm._v(_vm._s(item.value))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          item.assetsId === 20
            ? _c(
                "el-row",
                { key: index, staticClass: "row-gap" },
                [
                  _c(
                    "el-col",
                    { staticClass: "label-col", attrs: { span: 3 } },
                    [_vm._v("APP功能描述URL：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "value-col", attrs: { span: 21 } },
                    [_vm._v(_vm._s(item.value))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          item.assetsId === 21
            ? _c(
                "el-row",
                { key: index, staticClass: "row-gap" },
                [
                  _c(
                    "el-col",
                    { staticClass: "label-col", attrs: { span: 3 } },
                    [_vm._v("APP隐私政策URL：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "value-col", attrs: { span: 21 } },
                    [_vm._v(_vm._s(item.value))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          item.assetsId === 22
            ? _c(
                "el-row",
                { key: index, staticClass: "row-gap" },
                [
                  _c(
                    "el-col",
                    { staticClass: "label-col", attrs: { span: 3 } },
                    [_vm._v("APP权限列表URL：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "value-col", attrs: { span: 21 } },
                    [_vm._v(_vm._s(item.value))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          item.assetsId === 23
            ? _c(
                "el-row",
                { key: index, staticClass: "row-gap" },
                [
                  _c(
                    "el-col",
                    { staticClass: "label-col", attrs: { span: 3 } },
                    [_vm._v("下载开始监控：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "value-col", attrs: { span: 21 } },
                    [
                      _c(
                        "ul",
                        _vm._l(item.value.split(","), function(link, index) {
                          return _c(
                            "li",
                            { key: index, staticClass: "track-link" },
                            [_vm._v(_vm._s(link))]
                          )
                        }),
                        0
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          item.assetsId === 24
            ? _c(
                "el-row",
                { key: index, staticClass: "row-gap" },
                [
                  _c(
                    "el-col",
                    { staticClass: "label-col", attrs: { span: 3 } },
                    [_vm._v("下载完成监控：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "value-col", attrs: { span: 21 } },
                    [
                      _c(
                        "ul",
                        _vm._l(item.value.split(","), function(link, index) {
                          return _c(
                            "li",
                            { key: index, staticClass: "track-link" },
                            [_vm._v(_vm._s(link))]
                          )
                        }),
                        0
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          item.assetsId === 25
            ? _c(
                "el-row",
                { key: index, staticClass: "row-gap" },
                [
                  _c(
                    "el-col",
                    { staticClass: "label-col", attrs: { span: 3 } },
                    [_vm._v("安装开始监控：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "value-col", attrs: { span: 21 } },
                    [
                      _c(
                        "ul",
                        _vm._l(item.value.split(","), function(link, index) {
                          return _c(
                            "li",
                            { key: index, staticClass: "track-link" },
                            [_vm._v(_vm._s(link))]
                          )
                        }),
                        0
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          item.assetsId === 26
            ? _c(
                "el-row",
                { key: index, staticClass: "row-gap" },
                [
                  _c(
                    "el-col",
                    { staticClass: "label-col", attrs: { span: 3 } },
                    [_vm._v("安装完成监控：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "value-col", attrs: { span: 21 } },
                    [
                      _c(
                        "ul",
                        _vm._l(item.value.split(","), function(link, index) {
                          return _c(
                            "li",
                            { key: index, staticClass: "track-link" },
                            [_vm._v(_vm._s(link))]
                          )
                        }),
                        0
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ]
      }),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "row-gap" },
        [
          _c("el-col", { staticClass: "label-col", attrs: { span: 3 } }, [
            _vm._v("每日最大展示数：")
          ]),
          _vm._v(" "),
          _c("el-col", { staticClass: "value-col", attrs: { span: 21 } }, [
            _vm._v(_vm._s(_vm.entity.dayShowNum))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "row-gap" },
        [
          _c("el-col", { staticClass: "label-col", attrs: { span: 3 } }, [
            _vm._v("每日最大点击数：")
          ]),
          _vm._v(" "),
          _c("el-col", { staticClass: "value-col", attrs: { span: 21 } }, [
            _vm._v(_vm._s(_vm.entity.dayClickNum))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "row-gap" },
        [
          _c("el-col", { staticClass: "label-col", attrs: { span: 3 } }, [
            _vm._v("备注：")
          ]),
          _vm._v(" "),
          _c("el-col", { staticClass: "value-col", attrs: { span: 21 } }, [
            _vm._v(_vm._s(_vm.entity.remark))
          ])
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24ea7ec3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24ea7ec3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/idea/DetailTemplate.vue
// module id = 5unP
// module chunks = 1